import { Controller } from "@hotwired/stimulus"

// Handles the create tax organizer modal
// Populates account data and resets form when modal opens
export default class extends Controller {
  static targets = ["customerName", "taxYear", "copyCheckbox"]
  static values = {
    accountName: String,
    accountId: String
  }

  connect() {
    // Listen for Bootstrap modal show event
    this.element.addEventListener('show.bs.modal', this.handleModalShow.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('show.bs.modal', this.handleModalShow.bind(this))
  }

  handleModalShow(event) {
    // Get the button that triggered the modal
    const button = event.relatedTarget

    if (button) {
      const accountName = button.getAttribute('data-account-name')
      const accountId = button.getAttribute('data-account-id')

      // Populate customer name
      if (this.hasCustomerNameTarget && accountName) {
        this.customerNameTarget.textContent = accountName
      }

      // Store account ID for form submission
      this.accountIdValue = accountId || ''
    }

    // Reset form fields
    this.resetForm()
  }

  resetForm() {
    if (this.hasTaxYearTarget) {
      this.taxYearTarget.value = ''
    }

    if (this.hasCopyCheckboxTarget) {
      this.copyCheckboxTarget.checked = false
    }
  }
}
